/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MsftIconButton',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'absolute/stringmanager', 'util/SettingsManager'],

    function (PIXI, Absolute, _, MsftButton, StringManager, SettingsManager) {

        var MsftIconButton = function (options) {
            this._initMsftIconButton(options);
        };

        MsftIconButton.constructor = MsftIconButton;
        MsftIconButton.prototype = Object.create(MsftButton.prototype);

        MsftIconButton.prototype._initMsftIconButton = function (options) {
            this._options = options;
            this.fontSize = Absolute.ScreenMetrics.getResScale() * 17;
            if (options && options.fontSize)
                this.fontSize = options.fontSize;

            var defaultOptions = {
                letterStyle: {
                    font: this.fontSize + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                upStroke: true
            };

            MsftButton.call(this, _.extend(defaultOptions, options));

            if (this.options.label) {
                this.label = new PIXI.Text(this.options.label.text.toString(), this.options.label.letterStyle);
                this.label.x = (this.width - this.label.width) / 2;
                this.label.y = -Absolute.Coords.y(3);
                this.addChild(this.label);
            }

        };

        MsftIconButton.prototype.coolDown = function (ms) {
            this.interactive = false;
            clearTimeout(this.coolDownTimeout);
            this.coolDownTimeout = setTimeout(function () {
                if (!this) return;
                this.interactive = true;
            }.bind(this), ms)
        };

        MsftIconButton.prototype._createTexture = function (threeSliceOptions, type, isGame, isTopBarButton) {
            if (type === 'down') {
                this.options.letterStyle.fill = '#000001';
            } else if (type === 'active' || type === 'up' || type === 'over') {
                this.options.letterStyle.fill = '#ffffff';
            }
            var container = new PIXI.DisplayObjectContainer(),
                background = new PIXI.Graphics(),
                stroke = new PIXI.Graphics(),
                strokeWeight = Math.ceil(Absolute.Coords.x(1)),
                strokeOpacity = type === 'up' ? 0.5 : 1,
                text = new PIXI.Text(this.options.text, _.cloneDeep(this.options.letterStyle));

            if (!isGame && this.options.buttonOptions) {
                var options = this.options.buttonOptions;
                background.beginFill(
                    type === 'over' ? 0xffffff : (type === 'down' ? options.isDownBkgColor : options.isUpBkgColor),
                    type === 'down' ? 0.7 : (type === 'active' ? 0 : 0.3));
                background.drawRect(0, 0, this.options.width, this.options.height);
                background.endFill();

                stroke.lineStyle(strokeWeight,
                    type === 'down' ? options.isDownStrokeColor : options.isUpStrokeColor, type === 'down' ? 1 : strokeOpacity);
                stroke.beginFill(type === 'down' ? 0xffffff : (type === 'over' ? options.isOverStrokeFill : options.isUpStrokeFill));
                stroke.drawRect(0, 0, this.options.width - strokeWeight * 4, this.options.height - strokeWeight * 4);
                stroke.endFill();

            } else {
                background.beginFill(type === 'down' ? 0xffffff : 0x000001,
                    (type === 'down' || type === 'active') ? 1 : (type === 'over' ? 0.3 : (this.options.backgroundOpacity || 0.2)));
                background.drawRect(0, 0, this.options.width, this.options.height);
                background.endFill();

                stroke.lineStyle(strokeWeight, type === 'down' || type === 'active' ? 0x000001 : (isTopBarButton) ? 0x707886 : 0xffffff,
                    (type === 'down' || isTopBarButton) ? 0.08 : (type === 'down' || type === 'active') ? 1 : strokeOpacity);
                stroke.beginFill((type === 'over' && isTopBarButton) ? 0x507DAD : (type === 'up' ? 0x000001 : 0xffffff),
                    ((type === 'over' && isTopBarButton) || type === 'down') ? 1 : (type === 'up' || type === 'active') ? 0.2 : 0.1);
                stroke.drawRect(0, 0, this.options.width - strokeWeight * 4, this.options.height - strokeWeight * 4);
                stroke.endFill();
            }

            stroke.x = strokeWeight * 2;
            stroke.y = strokeWeight * 2;
            if (this.options.maxWidth) {
                StringManager.shrinkToFit(text, this.fontSize, '', this.options.maxWidth);
            }
            text.x = (this.options.width - text.width) / 2;
            text.y = this.options.textY || Absolute.Coords.y(35);

            container.addChild(background);
            container.addChild(stroke);

            if (this.options.icon) {
                this.icon = PIXI.Sprite.fromFrame(type === 'down' ? this.options.iconDown : this.options.icon);
                if (this.options.iconSize) {
                    this.icon.width = this.options.iconSize.width;
                    this.icon.height = this.options.iconSize.height;
                }
                this.icon.x = (this.options.width - this.icon.width) / 2;
                
                if (this.options.iconY)
                    this.icon.y = Absolute.Coords.y(12 + this.options.iconY);
                else
                    this.icon.y = Absolute.Coords.y(12);

                container.addChild(this.icon);
            }
            container.addChild(text);

            return container.generateTexture();

        };

        MsftIconButton.prototype.rotateIcon = function () {
            var layoutDir = (SettingsManager.getSetting('pyramid', 'layoutDirection') === '1') ? 'left' : 'right';
            this.lastPosition = {x: this.x, y: this.y};
            this.options.letterStyle.fill = '#ffffff';
            var parent = this.parent;
            parent.removeChild(this);
            this.options.icon = 'btn_pyramid_draw_' + layoutDir + '.png';
            this.options.iconDown = 'btn_pyramid_draw_inv_' + layoutDir + '.png';
            this._initMsftIconButton(this.options);
            parent.addChild(this);
            this.position.set(this.lastPosition.x, this.lastPosition.y);
        };

        MsftIconButton.prototype.bindMouseEvents = function () {
            this.mouseover = function (evt) {
                this.setTexture(this.overTexture);
                if (this._options.interaction) {
                    this._options.interaction('#ffffff');
                }
            };

            this.mouseout = function (evt) {
                this.setTexture(this.upTexture);
                if (this._options.interaction) {
                    this._options.interaction('#ffffff');
                }
            };

            this.mousedown = function (evt) {
                this.setTexture(this.downTexture);
                if (this._options.interaction) {
                    this._options.interaction('#000001');
                }
            };

            this.mouseup = function (evt) {
                this.setTexture(this.upTexture);
                this.handleAction();
                this.mouseover();
                if (this._options.interaction) {
                    this._options.interaction('#ffffff');
                }
            };
        };

        MsftIconButton.prototype.updateTexture = function (isGame) {
            this.upTexture = this._createTexture(this.options, 'up', isGame, true);
            this.downTexture = this._createTexture(this.options, 'down', isGame, true);
            this.overTexture = this._createTexture(this.options, 'over', isGame, true);
            this.setTexture(this.upTexture);
        };

        return MsftIconButton;

    });

